// src/mutationCache.ts
import { MutationCache as MC } from "@tanstack/query-core";
import { cloneDeepUnref } from "./utils.js";
var MutationCache = class extends MC {
  find(filters) {
    return super.find(cloneDeepUnref(filters));
  }
  findAll(filters = {}) {
    return super.findAll(cloneDeepUnref(filters));
  }
};
export {
  MutationCache
};
//# sourceMappingURL=mutationCache.js.map